let swimSize = 12;
let optionData = null;

function getRollingCoverVariants() {
  if (
    window.ShopifyAnalytics &&
    window.ShopifyAnalytics.meta &&
    window.ShopifyAnalytics.meta.product &&
    Array.isArray(window.ShopifyAnalytics.meta.product.variants)
  ) {
    return window.ShopifyAnalytics.meta.product.variants;
  }

  if (window.meta && window.meta.product && Array.isArray(window.meta.product.variants)) {
    return window.meta.product.variants;
  }

  return [];
}

function formatRollingCoverMoney(cents) {
  const amount = Number(cents || 0) / 100;

  try {
    return new Intl.NumberFormat("en-CA", {
      style: "currency",
      currency: "CAD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch (error) {
    return `$${amount.toFixed(2)} CAD`;
  }
}

function syncRollingCoverPrice(index) {
  const variants = getRollingCoverVariants();
  const targetVariant = variants[index];

  if (!targetVariant || typeof targetVariant.price === "undefined") {
    return;
  }

  const formattedPrice = formatRollingCoverMoney(targetVariant.price);
  const priceTargets = document.querySelectorAll(
    '[id^="price-"] .price-item--regular, .product_temp1_totalDisplay .total_amount .price-item--regular, .product_temp1_totalDisplay .total_amount_header'
  );

  priceTargets.forEach((node) => {
    node.textContent = formattedPrice;
  });

  const affirmNode = document.querySelector(".affirm-as-low-as");
  if (affirmNode) {
    affirmNode.setAttribute("data-amount", String(targetVariant.price));
  }
}

function syncVariantIdToForm(sizeSelector, index) {
  const variants = getRollingCoverVariants();
  const targetVariant = variants[index];

  if (!sizeSelector || !targetVariant || !targetVariant.id) {
    return;
  }

  const formId = sizeSelector.getAttribute("form");
  const productForm = formId ? document.getElementById(formId) : sizeSelector.form;

  if (!productForm) {
    return;
  }

  let variantIdInput = productForm.querySelector('input[name="id"]');

  if (!variantIdInput) {
    variantIdInput = document.createElement("input");
    variantIdInput.type = "hidden";
    variantIdInput.name = "id";
    productForm.appendChild(variantIdInput);
  }

  variantIdInput.value = targetVariant.id;
  variantIdInput.dispatchEvent(new Event("input", { bubbles: true }));
  variantIdInput.dispatchEvent(new Event("change", { bubbles: true }));
}

function getRollingCoverForm() {
  const sizeSelector = document.querySelector("select[name='options[Size]']");
  const formId = sizeSelector ? sizeSelector.getAttribute("form") : null;

  if (formId) {
    return document.getElementById(formId);
  }

  return document.querySelector('form[id^="product-form-"]');
}

function setRollingCoverError(message) {
  const errorBox = document.getElementById("errorMessage");

  if (!errorBox) return;

  errorBox.textContent = message || "";
  errorBox.style.display = message ? "block" : "none";

  if (message) {
    errorBox.scrollIntoView({ behavior: "smooth", block: "center" });
  }
}

function validateRollingCoverForm() {
  const colorValue = ($("#selected-color-input").val() || "").trim();
  const dimensionA = ($(".input-a-value").val() || "").toString().trim();
  const dimensionB = ($(".input-b-value").val() || "").toString().trim();
  const dimensionC = ($(".input-c-value").val() || "").toString().trim();
  const measurementsConfirmed = $(".emu-confirmation-checkbox").is(":checked");

  if (!colorValue) {
    setRollingCoverError("Please select a color.");
    return false;
  }

  if (!dimensionA || !dimensionB || !dimensionC) {
    setRollingCoverError("Please enter all required dimensions before adding to cart.");
    return false;
  }

  if (!measurementsConfirmed) {
    setRollingCoverError("Please confirm your measurements before adding to cart.");
    return false;
  }

  setRollingCoverError("");
  return true;
}

function forceShopifyVariantUpdate(selector, index) {
  const sizeSelector = document.querySelector(selector);

  if (!sizeSelector || typeof index !== "number" || index < 0) {
    return;
  }

  if (sizeSelector.selectedIndex === index) {
    syncRollingCoverPrice(index);
    syncVariantIdToForm(sizeSelector, index);
    sizeSelector.dispatchEvent(new Event("input", { bubbles: true }));
    sizeSelector.dispatchEvent(new Event("change", { bubbles: true }));
    return;
  }

  sizeSelector.selectedIndex = index;
  sizeSelector.value = sizeSelector.options[index] ? sizeSelector.options[index].value : sizeSelector.value;

  syncRollingCoverPrice(index);
  syncVariantIdToForm(sizeSelector, index);
  sizeSelector.dispatchEvent(new Event("input", { bubbles: true }));
  sizeSelector.dispatchEvent(new Event("change", { bubbles: true }));
}

function setupPanelConfig() {
  let rawDataElement = $("#option-data");

  if (!rawDataElement.length) {
    return;
  }

  let rawData = rawDataElement.attr("data-json");
  optionData = JSON.parse(rawData);

  let size = optionData.Size || [];

  const $select = $(".fsk-foldType-length");

  if (!$select.length) {
    return;
  }

  let currentValue = $select.val();

  $select.empty();

  let sizeObj = size.find(s => String(s.name).replace("'", "") == swimSize);

  if (!sizeObj) {
    console.warn("Size not found:", swimSize);
    return;
  }

  let folds = sizeObj.folds || [];

  $select.append(
    $('<option>', {
      value: '',
      text: '-- Choose Panel Configuration --'
    })
  );

  folds.forEach(fold => {
    $select.append(
      $('<option>', {
        value: fold.value,
        text: fold.name,
        'data-index': fold.index
      })
    );
  });

  if (currentValue && $select.find(`option[value="${currentValue}"]`).length) {
    $select.val(currentValue);
  }
}

function updateTaperSelection() {

    /////////////////////////////////////////////
    /* add colors *//////////////////////////////
    /////////////////////////////////////////////

    let colours = optionData.Colour || [];
    let color_standard_container = $(".color-standard-container");
    let color_atlantis_container = $(".color-atlantis-container");
    let us_color_button_container = $(".us-color-button-container");
    let weatherShield_color_container = $(".weatherShield-color-container");

    color_standard_container.empty();
    color_atlantis_container.empty();

    us_color_button_container.empty();
    weatherShield_color_container.empty();

    function buildDataAttrs(obj, region) {
      const r = obj[region] || {};
      let attrs = "";

      if (r.ALL) {
        attrs += ` data-${region}-all-price="${r.ALL.price}"`;
        attrs += ` data-${region}-all-index="${r.ALL.index}"`;
      }

      Object.keys(r).forEach(k => {
        if (k === "ALL") return;
        attrs += ` data-${region}-${k}-price="${r[k].price}"`;
        attrs += ` data-${region}-${k}-index="${r[k].index}"`;
      });

      return attrs;
    }

    colours.forEach((Colour) => {

      let color_card = `
        <div
          class="color-button ${Colour.name}"
          data-propertie="${Colour.name_properties}"
          ${buildDataAttrs(Colour, "us")}
          ${buildDataAttrs(Colour, "cad")}
          data-color="${Colour.name.replace(/_/g, " ")}"
          data-image="${Colour.image}"
        >
          ${Colour.name.replace(/_/g, " ")}"
        </div>
      `;


      if(Colour.type == "fabric"){
        color_atlantis_container.append(color_card);
      }else if (Colour.type == "weatherShield"){
        weatherShield_color_container.append(color_card);
      }else if (Colour.type == "us-standard"){
        us_color_button_container.append(color_card);
      }else{
        color_standard_container.append(color_card);
      }
    });

    console.log("bind colors")
    bindColors();

    

}

function bindColors(){

  let $popup = $("#color-popup");

  $(".color-button").hover(
    function (event) {
      let colorName = $(this).data("color");
      let imageUrl = $(this).data("image");

      // Update popup content
      $popup.text(colorName);
      $popup.css({
        "background-image": `url(${imageUrl})`,
        "display": "flex",
      });

      // Position the popup near the hovered button
      let offset = $(this).offset();
      $popup.css({
        "top": offset.top - 320 + "px",
        "left": offset.left + 50 + "px"
      });
    },
    function () {
      $popup.hide();
    }
  );

  $(".color-button").on("click", function () {
    // Remove 'selected' class from all buttons and add it to the clicked one
    $(".color-button").removeClass("selected");
    $(this).addClass("selected");
    let color_name = $(this).data("color");
  
    color_name = (color_name || "").replace(/_/g, " ");

    $(".dtext_target").html(color_name);
    $("#selected-color-input").val(color_name)
    
  });
  
}

function checkModels() {
  console.log("load json");

  // Safely retrieve JSON from the data attribute
  const brandDataElement = $("#brand-data").attr("data-json");

  if (!brandDataElement) {
    console.log("Brand data attribute not found!");
    return;
  }

  let brandData;
  try {
    brandData = JSON.parse(brandDataElement);
    console.log("Parsed brandData:", brandData);

    if (!Array.isArray(brandData)) {
      console.error("Brand data is not an array! Check metafield structure.");
      return;
    }
  } catch (e) {
    console.error("Error parsing JSON:", e);
    return;
  }

  // Populate the brand dropdown

  var selectedBrand = getUrlParameter("brand");
  var selectedModel = getUrlParameter("model");
  var selectedModel_ = selectedModel; // raw version

  if (selectedBrand) {
    selectedBrand = selectedBrand.replace(/-/g, " ");
  }

  if (selectedModel) {
    selectedModel = selectedModel.replace(/-/g, " ");
  }

  //thecoverbrothers.ca/products/custom-spa-cover?brand=Amish-Country&model=Paradise
  https: $.each(brandData, function (index, brand) {
    $("#brand").append(
      $("<option>", {
        value: brand.brand,
        text: brand.brand,
      })
    );
  });

  // Handle brand selection
  $("#brand").on("change", function () {
    const selectedBrand = $(this).val();
    const modelDropdown = $("#model");

    // Reset and disable the model dropdown
    modelDropdown
      .html('<option value="">Select Model</option>')
      .prop("disabled", true);
    $("#details").hide();

    if (selectedBrand) {
      // Find the selected brand
      const brand = brandData.find((b) => b.brand === selectedBrand);

      if (brand && Array.isArray(brand.models)) {
        // Populate the model dropdown
        $.each(brand.models, function (index, model) {
          modelDropdown.append(
            $("<option>", {
              value: model.name,
              text: model.name,
            })
          );
        });

        modelDropdown.prop("disabled", false);

        $("#model").val(selectedModel);
        if (!$("#model").val()) {
          $("#model").val(selectedModel_);
        }

        $("#model").trigger("change");
      }
    }
  });

  // Handle model selection
  $("#model").on("change", function () {
    const selectedBrand = $("#brand").val();
    const selectedModel = $(this).val();

    if (selectedBrand && selectedModel) {
      // Find the selected brand and model
      const brand = brandData.find((b) => b.brand === selectedBrand);
      const model = brand.models.find((m) => m.name === selectedModel);

      if (model) {
        // Display measurements
        const measurementsList = $("#measurements");
        measurementsList.empty();
        $.each(model.measurements, function (key, value) {
          measurementsList.append(`<li>${key.toUpperCase()}: ${value}</li>`);
          $(".input-" + key + "-value").val(value);
        });
        updateSize();
      }
    } else {
      $("#details").hide();
    }



  });

  $("#brand").val(selectedBrand);
  $("#brand").trigger("change");
}

function updateSize() {
  let current_aside = parseFloat($(".input-a-value").val());
  console.log("current_aside", current_aside);

  if (Number.isNaN(current_aside)) {
    return;
  }

  let index = 0;

  if (current_aside <= 150) {
    index = 0;
  } else if (current_aside <= 173) {
    index = 1;
  } else if (current_aside <= 180) {
    index = 2;
  } else if (current_aside <= 192) {
    index = 3;
  } else if (current_aside <= 209) {
    index = 4;
  } else if (current_aside <= 231) {
    index = 5;
  } else if (current_aside <= 252) {
    index = 6;
  }

  forceShopifyVariantUpdate("select[name='options[Size]']", index);
}


$(document).on('click', '.plus_qty', function () {
  let input = $('#qty-total');
  let current = parseInt(input.val())
  let max = 99
  console.log("current", current)
  if (current < max) {
    input.val(current + 1).trigger('change');
  }
});

$(document).on('click', '.minus_qty', function () {
  let input = $('#qty-total');
  let current = parseInt(input.val()) || 1;
  let min = parseInt(input.attr('min')) || 1;

  if (current > min) {
    input.val(current - 1).trigger('change');
  }
});

$(document).ready(function () {

  setupPanelConfig();    
  checkModels();
  updateTaperSelection(); 

  setRollingCoverError("");

  $(document).on("input change", ".input-a-value, .input-b-value, .input-c-value, #selected-color-input", function () {
    if (($("#errorMessage").text() || "").trim()) {
      validateRollingCoverForm();
    }
  });

  $(document).on("input change", ".input-a-value, .input-b-value, .input-c-value", function () {
    updateSize();
  });

  const rollingCoverForm = getRollingCoverForm();
  if (rollingCoverForm) {
    rollingCoverForm.addEventListener("submit", function (event) {
      if (!validateRollingCoverForm()) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);
  }

});

 
